﻿import { throttle } from "@shared/Utils";

function stickyEvent(): void {
  const offsetEl = document.getElementById("sticky-container-pos");

  const element = document.getElementById("sticky-container");
  let elemHeight = 0;
  let elemPos = 0;
  let elemRect: ClientRect;
  let alignElTop = false;
  const bodyRect = document.body.getBoundingClientRect();

  if (element) {
    alignElTop = (element.dataset.alignTop ?? "false").toLowerCase() === "true";
    elemRect = offsetEl.getBoundingClientRect();
    elemPos = elemRect.top - bodyRect.top;
    elemHeight = element.getBoundingClientRect().height;

    // adding 5px for good measure
    // push element out of screen

    if (alignElTop === true) {
      element.style.top = `-${Math.round(elemHeight) + 5}px`;
    }
  } else {
    const containerBlock = document.querySelector<HTMLElement>(".sticky-container-block");
    containerBlock.style.display = "none";
    return;
  }

  function stickyScrollEvent(): void {
    const position = alignElTop ? "--top" : "--bottom";

    if (window.scrollY > elemPos || window.pageYOffset > elemPos) {
      // vis
      element.classList.remove(`sticky-container--hidden${position}`);
      element.classList.add(`sticky-container${position}`);
    } else {
      element.classList.add(`sticky-container--hidden${position}`);
      element.classList.remove(`sticky-container${position}`);
    }
  }

  window.addEventListener("scroll", throttle(stickyScrollEvent, 100));
}

window.addEventListener("DOMContentLoaded", stickyEvent);
